import { render, staticRenderFns } from "./GoodsVideo.vue?vue&type=template&id=dda20292&scoped=true"
import script from "./GoodsVideo.vue?vue&type=script&lang=js"
export * from "./GoodsVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda20292",
  null
  
)

export default component.exports